import {classNames, observer, React, useEffect} from '@api'
import {CatalogFilters, SidebarAggregateDetails, StoresInstanceContext, useStores} from '@modules'
import {CatalogRootFlexLayoutStoreContext, FlexLayoutComponentProps} from '@stores'
import * as css from './AggregationsFlexLayout.css'

export const AggregationsFlexLayout = observer<FlexLayoutComponentProps>(function AggregationsFlexLayout(props) {
  const stores = useStores(),
    {filter, flexLayout: {activeOrLastCatalogRoot: catalogRoot}} = stores

  useEffect(() => {
    filter.everVisible = true
  }, [filter.everVisible])

  if (!catalogRoot) return null

  const storesToInject = catalogRoot.storesToInject
  // console.log(props)

  if (!storesToInject) return null

  return (<div className={classNames(props.className, css.root)}>
    <CatalogRootFlexLayoutStoreContext.Provider value={catalogRoot}>
      <StoresInstanceContext.Provider value={storesToInject}>
        {storesToInject.catalog?.aggregation?.hasAggregations ? <SidebarAggregateDetails key={storesToInject?._id} /> : <span className={css.noAggs}>Aggregations are not configured for {storesToInject?.workspace ? ` the '${storesToInject.workspace.title}'` : 'this'} Workspace</span>}
      </StoresInstanceContext.Provider>
    </CatalogRootFlexLayoutStoreContext.Provider>
  </div>)
})



// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexComponents/toolbox-items/AggregationsFlexLayout.tsx